import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { LocationSettingsComponent } from "./location-settings/location-settings.component";

const routes: Routes = [
	{
		path: "",
		component: LocationSettingsComponent,
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class LocationSettingsRoutingModule {}
